import { toast } from 'react-toastify';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import header from '../../../assets/icm-header.jpg';
import {
  getBase64PDFImage,
  scaleStyles,
  baseStyles,
  getPrefix,
} from '../../../util/utils';
import {
  getPdfBase64,
  enviarArquivo,
  normalizeWhatsappPhone,
} from '../../../services/pdfWhatsapp';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default async function generateStressPDF(stress, tipo, fontScale = 0.9) {
  const styles = scaleStyles(baseStyles, fontScale);
  const headerImage =
    tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
      ? await getBase64PDFImage(header)
      : null;

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: headerImage ? [40, 130, 40, 60] : [40, 80, 40, 60],
    footer: (currentPage, pageCount) => {
      return {
        columns: [
          {
            text: `Página ${currentPage} de ${pageCount}`,
            alignment: 'center',
            style: 'footer',
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },
    content: [
      {
        text: 'ECOCARDIOGRAMA DE ESTRESSE',
        style: 'title',
        alignment: 'center',
        margin: [0, 0, 0, 0],
      },
      // --- Cabeçalho com retângulo preto ---
      {
        table: {
          widths: ['*'], // ocupa toda a largura
          body: [
            [
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `Nome do Paciente: ${stress.CODPAC} - ${stress.NOMEPAC}`,
                        width: '100%',
                        bold: true,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `Data Nasc: ${stress.dataNasc}`,
                        width: '50%',
                      },
                      {
                        text: `Sexo: ${stress.SEXOPAC}`,
                        width: '20%',
                      },
                      {
                        text: `Idade: ${stress.idadePAC} anos`,
                        width: '30%',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `Convênio: ${stress.SIGLACONV}`,
                        width: '50%',
                      },
                      {
                        text: `Código: ${stress.CODSTRESS}`,
                        width: '20%',
                      },
                      {
                        text: `Data Laudo: ${stress.dataStress}`,
                        width: '30%',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `Médico que Solicitou: ${getPrefix(
                          stress?.CODSOLICITANTE
                        )} ${stress.Solicitou}`,
                        width: '100%',
                      },
                    ],
                  },
                ],
                margin: [10, 0, 10, 0],
              },
            ],
          ],
        },
        layout: {
          // Desenha borda preta ao redor
          hLineWidth: () => {
            return 1;
          },
          vLineWidth: () => {
            return 1;
          },
          hLineColor: () => {
            return 'black';
          },
          vLineColor: () => {
            return 'black';
          },
        },

        style: 'content',
      },

      // Conteúdo ISQUEMIA / Descrição do exame ---
      {
        text: stress.ISQUEMIA,
        style: 'content',
        margin: [0, 5, 0, 25],
      },
      {
        text: `Imagens disponíveis no site: www.icm.com.br (Resultado de Exames)\nCódigo de verificação: ${stress.CODPAC}`,
        style: 'smaller',
        italics: true,
        alignment: 'left',
      },

      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                stack: [
                  {
                    text: `Conferido e assinado eletronicamente por: ${getPrefix(
                      stress?.CODREALIZOU
                    )} ${stress.Realizou} - CRM: ${stress.CRMMED} - RQE: ${
                      stress.RQE
                    }`,
                    bold: true,
                    italics: true,
                    style: 'smaller',
                    alignment: 'center',
                  },
                  {
                    text: `Assinatura Digital: ${stress.HASH || ''}`,
                    italics: true,
                    style: 'smaller',
                    alignment: 'center',
                  },
                  {
                    text: [
                      { text: 'Emitido em: ', bold: true },
                      `${new Date().toLocaleString('pt-BR')}\n`,
                    ],
                    style: 'smaller',
                    italics: true,
                    color: '#444',
                    alignment: 'center',
                  },
                ],
                style: 'small',
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: '#999',
          vLineColor: '#999',
          paddingLeft: () => 5,
          paddingRight: () => 5,
          paddingTop: () => 5,
          paddingBottom: () => 5,
        },
        margin: [0, 1, 0, 1],
      },
    ],
    styles,
  };

  // Adiciona header apenas quando houver imagem
  if (headerImage) {
    docDefinition.header = {
      image: headerImage,
      width: 500,
      alignment: 'center',
      margin: [0, 10, 0, 0],
    };
  }

  if (tipo === 'imprimirNormal' || tipo === 'imprimirTimbrado') {
    pdfMake.createPdf(docDefinition).open();
  } else {
    const celular = normalizeWhatsappPhone(stress?.CELULARPAC);
    if (!celular) {
      toast.warn('Número de celular não encontrado!');
      return;
    }

    try {
      const pdfGenerator = pdfMake.createPdf(docDefinition);
      const pdfBase64 = await getPdfBase64(pdfGenerator);
      const data = await enviarArquivo({
        to: celular,
        pdfBase64,
        paciente: {
          id: stress?.CODPAC,
          nome: stress?.NOMEPAC,
          medico: stress?.Realizou,
        },
        codLaudo: stress?.CODSTRESS,
        fileName: `Laudo_Stress_${stress?.CODSTRESS}.pdf`,
        caption: `Olá *${stress?.NOMEPAC}*, tudo bem? 😊

Segue em anexo o seu *Laudo de Ecocardiograma de Estresse*.

As *imagens do exame* podem ser acessadas pelo link:
👉 http://www.icm.com.br (Resultados de Exames)

Qualquer dúvida, nossa equipe estará à disposição no setor de atendimento pelo WhatsApp 14-3402-5252\n
ICM - Instituto do Coração de Marília`,
        officialConfig: {
          procedimento: 'stress',
          documentTitle: 'Laudo de Ecocardiograma de Estresse',
        },
      });
      toast.success(data.message);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.message ||
        'Erro ao enviar laudo via WhatsApp';
      toast.error(errorMessage);
    }
  }

  return docDefinition;
}
